'use strict';

angular.module('atex.dam').controller('DamMainController', ['$rootScope', '$scope', 'AuthenticationService',
  'Application','DamListService','$state', '$translate', 'DamActivityService', 'configuration',
function($rootScope, $scope, AuthenticationService,
         Application, DamListService, $state, $translate, DamActivityService, configuration) {

  $scope.$state = $state;

  $scope.show = false;
  $scope.busyCursor = false;
  $rootScope.$on("dam:busyCursor", function (event, data) {
    $scope.busyCursor = data;
  });

  $scope.$on("onecms:authenticationSuccess", function () {
    AuthenticationService.getCurrentUser().then(function (user) {
      if ((user !== undefined) && (user !== 'Unknown User')) {
        $scope.show = true;
      }
    });
    $scope.show = true;
  });

  AuthenticationService.getCurrentUser().then(function (user) {
    if ((user !== undefined) && (user !== 'Unknown User')) {
      $scope.show = true;
    }
  });

  $scope.$on("dam:logout", function () {
    $scope.show = false;
  });

  $scope.createSendList = function(selected) {
    var toSend = [];

    angular.forEach(selected, function (value) {
      var item = {};
      item.contentid = value._data.id;
      item.type = atex.onecms.AngularUtils.fromDeskTypeToHermesType(value._data.aspects.contentData.data.inputTemplate);
      item.inputTemplate = value._data.aspects.contentData.data.inputTemplate;
      item.name = encodeURIComponent(value._data.aspects.contentData.data.name);
      item._type = value._data.aspects.contentData.data._type;
      // First check if we have a specific type, for this inputTemplate, to set in the url
      var cfgDragType = configuration.getDragType(item.inputTemplate);
      if (cfgDragType) {
        item.type = cfgDragType;
      }
      // Patch to handle custom articles and images
      if (item.type === "unknown") {
        if (item._type === 'atex.onecms.image') {
          item.type = "photo";
        } else if (item._type === 'atex.onecms.article') {
          item.type = "text";
        }
      }
      toSend.push(item);
    });

    return toSend;
  };

  $scope.createDragUrl = function (selected) {
    var toSend = $scope.createSendList( selected );

    if( toSend.length === 0 ) {
      return;
    }

    var url = "dataapiurl=";
    if (!window.location.origin) {
      window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    }
    url += window.location.origin;
    url += "/onecms/";
    url += "&contentlist=";
    url += JSON.stringify(toSend);
    url += "&token=";
    url += Application.currentUser.token;
    return url;
  };

  $scope.createAdmJson = function(selected) {
    var toSend = $scope.createSendList( selected );

    if( toSend.length === 0 ) {
      return;
    }

    var admJson = {
      contentList: toSend,
      origin: window.location.origin,
      token: Application.currentUser.token
    };

    return JSON.stringify( admJson );
  };

  $scope.getIdsFromDragUrl = function (dragUrl) {
    var contentIds = [];
    var urlparts = dragUrl.split('&');

    angular.forEach(urlparts, function (part) {
      var map = part.split("=");
      if (map[0] === 'contentlist') {
        var objs = JSON.parse(map[1]);
        angular.forEach(objs, function (obj) {
          contentIds.push(obj.contentid);
        });
      }
    });
    return contentIds;
  };

  function lockObjects( objs ) {
    var contentIds = [];

    objs.forEach(function (obj) {
      contentIds.push( obj._data.id );
    });

    if ( !_.isEmpty(contentIds ) ) {
      DamActivityService.lock(contentIds).then(function (responses) {
        $scope.draggingContentIds = contentIds;
      }).catch(function(error) {
        $scope.draggingContentIds = [];
      });
    }
  }

  function unlockObjects( contentIds ) {

    if ( !_.isEmpty(contentIds ) ) {
      DamActivityService.unlock(contentIds).then(function (responses) {
        $scope.draggingContentIds = [];
      }).catch(function(error) {
        $scope.draggingContentIds = [];
      });
    }
  }

  $scope.handleDragStart = function (event) {
    this.style.opacity = '0.4';

    var objs = [];
    if (DamListService.getSelected().length > 0) {
      angular.copy(DamListService.getSelected(), objs);
    }

    if ((this.attributes.contentId.value !== undefined) && (this.attributes.type.value !== undefined)) {
      var obj = {};
      obj._data = {};
      obj._data.id = this.attributes.contentId.value;

      obj._data.aspects = {};
      obj._data.aspects.contentData = {};
      obj._data.aspects.contentData.data = {};
      obj._data.aspects.contentData.data.inputTemplate = this.attributes.type.value;
      obj._data.aspects.contentData.data.name = this.attributes.name ? this.attributes.name.value : '';
      obj._data.aspects.contentData.data._type = this.attributes.contentType.value;

      var contains = false;
      objs.forEach(function (tmp) {
        if (tmp._data.id === obj._data.id) {
          contains = true;
        }
      });

      if (!contains) {
        objs.length = 0;
        objs.push(obj);
      }

    }

    var _type = this.attributes.contentType.value;
    var name = this.attributes.name ? this.attributes.name.value : '';

    var dragUrl;
    if (this.attributes.dragUrl) {
      dragUrl = this.attributes.dragUrl.value;
    }

    var e = event.originalEvent;
    if (e.srcElement.parentNode) {
      var ghost = document.getElementById('drag-ghost-container');
      if (ghost && ghost.parentNode) {
        ghost.parentNode.removeChild(ghost);
      }

      var container = document.createElement('div');
      container.id = 'drag-ghost-container';

      var img = document.createElement('img');
      img.id = 'drag-ghost-widget';

      if (objs.length > 1) {
        img.src = "img/multiple.png";
      } else if (dragUrl) {
        img.id = 'drag-ghost-img';
        img.src = dragUrl;
      } else if ('atex.dam.standard.Video' === _type) {
        img.src = "img/video.png";
      } else if ('atex.dam.standard.Embed' === _type) {
        img.src = "img/embed.png";
      } else if ('atex.onecms.image' === _type) {
        img.src = "img/image.png";
      } else if ('atex.onecms.article' === _type) {
        img.src = "img/article.png";
      } else {
        img.src = "img/generic.png";
      }

      var label = $translate.getTranslationTable()['__MULTIPLE_SELECTION__'] || 'Multiple selection';
      var text = document.createElement('div');
      text.innerHTML = (objs.length > 1) ? label : name;
      text.id = 'drag-ghost-text';

      container.appendChild(img);
      container.appendChild(text);

      document.body.appendChild(container);
      e.dataTransfer.setDragImage(container, 0, 0);
    }
    event.originalEvent.dataTransfer.setData('Text', $scope.createDragUrl(objs));
    event.originalEvent.dataTransfer.setData('application/adm+json+' + $scope.createAdmJson(objs), "{}");
  };

  $scope.handleDragEnd = function (e) {
    this.style.opacity = '1';
  };

  $scope.mainRowFixedHeight = false;
  $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
    $scope.mainRowFixedHeight = toState.name === 'list';
  });

}]);
